import createVueComponent from '../createVueComponent';

const CircleSlash2 = createVueComponent('CircleSlash2Icon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['path', { d: 'M22 2 2 22', key: 'y4kqgn' }],
]);

export default CircleSlash2;
